import 'waypoints/lib/noframework.waypoints.js';

let elements = document.querySelectorAll('[data-waypoint]');

export default {
    init() {
        elements.forEach(function (element) {
            let wp = new window.Waypoint({
                element,
                handler: function() {
                    element.classList.add('js-in');

                    wp.destroy();
                },
                offset: '90%',
            });
        });
    },
}


// WEBPACK FOOTER //
// ./scripts/components/waypoints.js